import { Injectable } from '@angular/core';
import { Subject, Observable, Subscriber } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http'

import { IContact,IContactMessage, IAboutUs } from '../model/app.model'


@Injectable()
export class homeComponentService {
  hostName = "http://api.flashqubes.com/v1-0";

  constructor(private http: Http) { }

  


  getContact(): Observable<IContact> {

    let header = new Headers({ 'content-type': 'application/json' });
    
    //header.append("Authorization","");
    

    let opt = new RequestOptions({ headers: header });
    console.log(opt);
    return this.http.get("https://api.flashqubes.com/v1-0/contacts",opt).map((response: Response) => {

      console.log(JSON.stringify(response.json()));
			return <IContact>response.json();
		}).catch(this.handleError);

  }

  getAboutUs(): Observable<IAboutUs> {
    return new Observable<IAboutUs>((subscriber: Subscriber<IAboutUs>) => subscriber.next(this.aboutus)).map(o => o);

  }





  private handleError(error: Response) {
    console.log("Error" );
    console.log(error.statusText );
    return Observable.throw(error.statusText);
  }

  saveEvent(contactMsg: IContactMessage) :Observable<IContactMessage>{
    let header = new Headers({ 'content-type': 'application/json' });
    
    //header.append("Authorization","");
    console.log(JSON.stringify(contactMsg));

    let opt = new RequestOptions({ headers: header });
    return this.http.post("https://api.flashqubes.com/v1-0/contacts", JSON.stringify(contactMsg), opt).map((response: Response) => {
      console.log("http response" + JSON.stringify(response.json()))
      return response.json().data;
    }).catch(this.handleError)

  }






  contact =
  { 

    phoneNumber: "201-696-8075",
    eMail: "flashqubes@gmail.com",


  }

  aboutus =
  {

    title: "Our Story",
    story: "",
    updateDate: new Date("2017-10-20")


  }


}



// WEBPACK FOOTER //
// /apps/dev/flashqubes/src/app/services/app.services.ts